import { DaoService } from './DaoService';
class SearchService extends DaoService {
    static getInstance() {
        return super.getInstance('search');  // Garde le préfixe de recherche
    }

    async search(query) {
        return SearchService.get(`${this.prefix}?searchText=${query}`);
    }
    
}
export default SearchService;